export const environment = {
  production: true,
  apiServerUrl: '/api/',
  displayLabelToolTip: false,
  authKeycloakUrl : 'https://auth.sgdf-prod.intrassoc.com',
  realmName: 'sgdf_production',
  authKeycloakRedirectUrl: 'https://monprojet.sgdf.fr',
  sentryDsn: 'https://499396db62bd92203ea044a74f966267@o4505998128250880.ingest.us.sentry.io/4506874914406400'
};
